import React from 'react';
import Page from '../components/PageTemplate'
import OutfitText from '../data/TextAreaInput/OutfitText'

const Outfits = () => {
    const titleSectionInput = {
        title: '',
        image: 'collage3.png',
        bgTint1: "rgba(0, 37, 84, 0.2)",
        bgTint2: "rgba(0, 37, 84, 0.5)",
        bgTint3: "rgba(0, 37, 84, 0.8)"
    }
    return ( <
        Page titleSection = { titleSectionInput }
        textArea = { < OutfitText / > }
        />
    )
}

export default Outfits